import { deleteCookie, getCookie } from "./cookie";
import { getQueryParamValue, isTokenStillValid, jwtDecode } from "./misc";
import LocalData from "../helpers/LocalData";
import Config from "../config";

const helpdeskBridgeCookieName = "hcn-admin-jwt-access-token";

export const checkAuthTokenUseCase = () => {
  let token =
    getTokenFromURL() ||
    getTokenFromCookieAndClear() ||
    LocalData.get(Config.LOCAL_DATA_KEYS.JWT_ACCESS_TOKEN);

  const validToken = token ? isTokenStillValid(token) : false;

  if (token && validToken) {
    LocalData.set(Config.LOCAL_DATA_KEYS.JWT_ACCESS_TOKEN, token);
  }
  return validToken;
};

const getTokenFromCookieAndClear = () => {
  const token = getCookie(helpdeskBridgeCookieName);
  if (!token) {
    return null;
  }

  deleteCookie(helpdeskBridgeCookieName);
  return token;
};

const getTokenFromURL = () => {
  return getQueryParamValue(window.location.search, "token");
};
